<template>
  <div class="sunny-box">
    <div class="wrapper">
      <div class="con">
        <div class="rec"></div>
        <div class="rec"></div>
        <div class="rec"></div>
        <div class="rec"></div>
        <div class="rec"></div>
        <div class="rec"></div>
        <div class="rec"></div>
        <div class="rec"></div>

        <!-- <div class="rec"></div>
      <div class="rec"></div>
      <div class="rec"></div>
      <div class="rec"></div> -->
      </div>
      <div class="color-div">
        <div></div>
      </div>
      <div class="cloud-inf">
        <img class="cloud3" src="/sk/skImage/云1.png" alt="" />
        <img class="cloud4" src="/sk/skImage/云2.png" alt="" />
      </div>
      <div class="cloud">
        <img class="cloud1" src="/sk/skImage/云1.png" alt="" />
        <img class="cloud2" src="/sk/skImage/云2.png" alt="" />
      </div>
      <div class="cloud-2">
        <img class="cloud1" src="/sk/skImage/云1.png" alt="" />
        <img class="cloud2" src="/sk/skImage/云2.png" alt="" />
      </div>
      <!-- <div class="cloud-2 cloud-3">
      <img class="cloud1" src="/sk/skImage/云1.png" alt="">
      <img class="cloud2" src="/sk/skImage/云2.png" alt="">
    </div> -->

      <div class="sun"><img src="/sk/skImage/sun.png" alt="" /></div>
      <div class="content">
        <!-- <img src="/sk/skImage/内容2.png" alt="" /> -->
      </div>
    </div>
  </div>
</template>
  
  <script>
import $ from "jquery";
import { nextTick } from "vue";
import {
  defineComponent,
  reactive,
  toRefs,
  onMounted,
  onBeforeUnmount,
} from "vue";
export default defineComponent({
  components: {},
  setup(props) {
    const proxyData = reactive({});
    onBeforeUnmount(() => {});
    onMounted(() => {
      nextTick(() => {});
    });
    return {
      ...toRefs(proxyData),
    };
  },
});
</script>
  
  <style lang="scss" scoped>
.sunny-box {
  width: 100vw;
  height: 100vh;
  position: relative;
  background: #5889c3;
  .con {
    position: fixed;
    top: 0px;
    right: 100px;
    height: 1000px;
    width: 50px;
    margin: 50px;
    padding: 10px;
    /* border: 1px solid black; */
    perspective: 200px;
    -webkit-perspective: 200px; /* Safari and Chrome */
    -webkit-transform-origin: 50% 0;
    -ms-transform-origin: 50% 0;
    transform-origin: 50% 0;
    animation: blink 40s infinite;
  }

  .con .rec {
    position: absolute;
    top: -100px;
    left: 0px;
    width: 20px;
    height: 1000px;
    background-image: linear-gradient(
      rgba(255, 255, 255, 1),
      rgba(255, 255, 255, 0.2)
    );
    opacity: 0.15;
    filter: blur(3px);
    -webkit-transform-origin: 50% 0;
    -ms-transform-origin: 50% 0;
    transform-origin: 50% 0;
  }

  .con .rec:nth-child(1) {
    -webkit-transform: rotateX(15deg) rotateY(0deg) rotateZ(0deg);
    transform: rotateX(15deg) rotateY(0deg) rotateZ(0deg);
    -webkit-animation-delay: 200ms;
    animation-delay: 200ms;
  }

  .con .rec:nth-child(2) {
    -webkit-transform: rotateX(15deg) rotateY(10deg) rotateZ(3deg);
    transform: rotateX(15deg) rotateY(10deg) rotateZ(3deg);
    -webkit-animation-delay: 600ms;
    animation-delay: 600ms;
  }

  .con .rec:nth-child(3) {
    -webkit-transform: rotateX(15deg) rotateY(15deg) rotateZ(6deg);
    transform: rotateX(15deg) rotateY(15deg) rotateZ(6deg);
    -webkit-animation-delay: 1000ms;
    animation-delay: 1000ms;
  }

  .con .rec:nth-child(4) {
    -webkit-transform: rotateX(15deg) rotateY(16deg) rotateZ(9deg);
    transform: rotateX(15deg) rotateY(16deg) rotateZ(9deg);
    -webkit-animation-delay: 1400ms;
    animation-delay: 1400ms;
  }
  .con .rec:nth-child(9) {
    -webkit-transform: rotateX(15deg) rotateY(16deg) rotateZ(10deg);
    transform: rotateX(15deg) rotateY(16deg) rotateZ(10deg);
    -webkit-animation-delay: 1400ms;
    animation-delay: 1400ms;
  }

  .con .rec:nth-child(5) {
    -webkit-transform: rotateX(15deg) rotateY(15deg) rotateZ(-3deg);
    transform: rotateX(15deg) rotateY(15deg) rotateZ(-3deg);
    -webkit-animation-delay: 1800ms;
    animation-delay: 1800ms;
  }

  .con .rec:nth-child(6) {
    -webkit-transform: rotateX(15deg) rotateY(5deg) rotateZ(-6deg);
    transform: rotateX(15deg) rotateY(5deg) rotateZ(-6deg);
    -webkit-animation-delay: 2200ms;
    animation-delay: 2200ms;
  }

  .con .rec:nth-child(8) {
    -webkit-transform: rotateX(15deg) rotateY(-5deg) rotateZ(-9deg);
    transform: rotateX(15deg) rotateY(-5deg) rotateZ(-9deg);
    -webkit-animation-delay: 2600ms;
    animation-delay: 2600ms;
  }

  @-webkit-keyframes blink {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(20deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  @keyframes blink {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(20deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  .wrapper {
    padding: 0px;
    margin: 0px;
    width: 100vw;
    height: 100vh;
    position: fixed;
    position: relative;
    overflow: hidden;
  }
  .content {
    width: 100vw;
    height: 100vh;
    position: fixed;
    text-align: center;
    top: 0px;
    left: 0px;
  }
  .content img {
    height: 100vh;
  }
  .color-div {
    height: 800px;
    width: 900px;
    border-radius: 50%;
    background-image: radial-gradient(
      rgba(255, 0, 0, 0) 50%,
      rgba(255, 0, 0, 0.1),
      rgba(255, 96, 0, 0.1),
      rgba(252, 255, 0, 0.1),
      rgba(53, 247, 5, 0.2),
      rgba(2, 221, 250, 0.2),
      rgba(24, 8, 247, 0.2),
      rgba(196, 7, 243, 0.2) 90%
    );

    filter: blur(30px);
    position: absolute;
    top: -350px;
    right: -200px;
    animation: circle 20s infinite;
  }
  @keyframes circle {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }
  .sun {
    position: fixed;
    top: -475px;
    right: 150px;
    width: 500px;
  }

  .cloud {
    position: absolute;
    left: -700px;
    width: 100vw;
    height: 100vh;
    animation: cloudMove 190s linear infinite;
  }
  .cloud-2 {
    position: absolute;
    left: -700px;
    width: 100vw;
    height: 100vh;
    animation: cloudMove 190s linear 90s infinite;
  }
  /* .cloud-3{
      position: absolute;
      left: -600px;
      width: 100vw;
      height: 100vh;
      animation: cloudMove 200s linear 120s infinite;
    } */
  .cloud1 {
    /* border:1px solid #333; */
    position: absolute;
    top: 60px;
    left: 0px;
    height: 350px;
  }
  .cloud2 {
    /* border:1px solid #962929; */

    position: absolute;
    top: 10px;
    left: -300px;
    height: 250px;
  }

  .cloud-inf {
    position: absolute;
    width: 100vw;
    height: 100vh;
    animation: cloudMove 200s linear forwards;
  }
  .cloud3 {
    /* border:1px solid #b62626; */
    position: absolute;
    top: 60px;
    left: 800px;
    height: 350px;
  }

  .cloud4 {
    position: absolute;
    top: 10px;
    left: 500px;
    height: 250px;
  }
  @keyframes cloudMove {
    0% {
      transform: translate(-800px, 0px);
    }
    100% {
      transform: translate(2000px, 0px);
    }
  }
}
</style>
  